<template>
  <div id="app">
    <formativetest query="https://studmed.uio.no/vp/quizasjson?quiztopic=Child%20abuse%20and%20neglect&qlist=1000_30373_&locale=en" />
  </div>
</template>

<script>

   import formativetest from './components/formativetest.vue'

   export default {
     name: 'App',
     components: {
       formativetest
     }
   }
   
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
